var css = {"container":"Tabs-module_container__eJ-sh","draggableContainer":"Tabs-module_draggableContainer__iHZNL","tab":"Tabs-module_tab__DEdzi","tabWithoutBlur":"Tabs-module_tabWithoutBlur__YgQtF"};

export { css as default };
